import tokens from '@ifood/pomodoro-tokens';
import styled, { FlattenSimpleInterpolation, css } from 'styled-components';
import { LayoutProps, SpaceProps, layout, space } from 'styled-system';

const DisabledStyle = css`
  border: solid 1px ${tokens.colors.grayDarker};
  color: ${tokens.colors.black};
  background-color: ${tokens.colors.gray};
`;

type StyleWrapperProps = {
  hasError?: boolean;
  disabled?: boolean;
} & SpaceProps &
  LayoutProps;

export const StyleWrapper = styled.div<StyleWrapperProps>`
  .inputClass {
    font-family: ${tokens.font.family.ifood.body};
    font-size: ${tokens.fontSizes.m};
    line-height: ${tokens.lineHeights.m};
    color: ${tokens.colors.black};
    border: solid 1px ${({ hasError }): string => (hasError ? tokens.colors.error : tokens.colors.gray)};
    border-radius: ${tokens.radii.m};
    overflow: hidden;
    padding: ${tokens.space.small} ${tokens.space.smaller};
    transition: box-shadow ${tokens.durations.quickly} ${tokens.timingFunctions.easeInOut};
    height: auto;
    padding-left: 50px;
    width: 100%;

    ${({ disabled = false }): FlattenSimpleInterpolation | false => disabled && DisabledStyle}

    &:focus-within {
      outline: none;
      border: solid 1px ${tokens.colors.primary};
      box-shadow: 0 0 0 1px ${tokens.colors.primary};
    }
  }

  .buttonClass {
    background-color: transparent;
    border-right: none;
    border-radius: ${tokens.radii.m} 0 0 ${tokens.radii.m};
    border: none;
  }

  .dropdownClass {
    border: none;
  }

  .react-tel-input .country-list {
    overflow-y: auto;
  }

  .react-tel-input {
    font-family: ${tokens.font.family.ifood.body};

    .country-name {
      color: ${tokens.colors.black};
    }

    .dial-code {
      color: ${tokens.colors.grayDarker};
    }
  }

  .react-tel-input .flag-dropdown.open,
  .react-tel-input .flag-dropdown.open .selected-flag,
  .react-tel-input .selected-flag:hover,
  .react-tel-input .selected-flag:focus {
    background-color: transparent;
  }

  ${layout}
  ${space}
`;
